import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DoneVisitsEmptyState from './DoneVisitsEmptyState';
import DoneVisitsContent from './DoneVisitsContent';
import PerformanceCard from '../PerformanceCard';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceDoneVisitsCard } from '@/store/slices/components/dashboard/service';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import { DONE_VISITS } from '../../constants';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '../../constants/track';

export default function DoneVisits() {
  const dispatch = useDispatch();
  const track = useTrackPerformanceTabCard();
  const { doneVisits } = useSelector((state) => state.DashboardSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const {
    loading,
    hasFetched,
    value,
    variation,
    percentage_status,
    icon,
    error,
  } = doneVisits;
  const [selectedOption, setSelectedOption] = useState(DONE_VISITS.VISIT);
  const showEmptyState = error || (hasFetched && value === 0);

  const allowedOptions = [
    { id: DONE_VISITS.VISIT, text: Trans(translations, 'Visit') },
    {
      id: DONE_VISITS.CLOSING_REASON,
      text: Trans(translations, 'ClosingReason'),
    },
    {
      id: DONE_VISITS.QUALIFICATION,
      text: Trans(translations, 'Qualification'),
    },
  ];

  const handleClickRadio = (item) => {
    setSelectedOption(item.id);
    track.visitsMade(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
  };

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceDoneVisitsCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'doneVisits',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard ref={ref} loading={loading || isStale} id="done-visits">
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'VisitsMade')}
      </PerformanceCard.Header>
      {showEmptyState ? (
        <DoneVisitsEmptyState />
      ) : (
        <>
          <PerformanceCard.Summary
            value={value}
            percentageStatus={percentage_status}
            tendency={variation}
            icon={icon}
          >
            <RadioButtonsGroup
              allowedOptions={allowedOptions}
              selectedOption={selectedOption}
              onClickRadio={handleClickRadio}
            />
          </PerformanceCard.Summary>
          <DoneVisitsContent selectedOption={selectedOption} />
        </>
      )}
    </PerformanceCard>
  );
}
